import { render } from "./ReferralDetailsPage.vue?vue&type=template&id=2098410e&scoped=true"
import script from "./ReferralDetailsPage.vue?vue&type=script&lang=js"
export * from "./ReferralDetailsPage.vue?vue&type=script&lang=js"

import "./ReferralDetailsPage.vue?vue&type=style&index=0&id=2098410e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2098410e"]])

export default __exports__